<template>
  <nuxt-link
    class="navigation-item flex transform flex-col items-center justify-center gap-2 whitespace-nowrap rounded-2xl px-3 py-1 text-center text-sm sm:hover:scale-105"
    :class="{
      [activeClass]: isActive,
      'text-slate-darker bg-white': !isActive,
    }"
    :to="to"
  >
    <div class="flex items-center sm:flex-1">
      <component :is="icon" class="icon h-9 w-9" />
    </div>
    <p>{{ label }}</p>
  </nuxt-link>
</template>

<script setup lang="ts">
const props = withDefaults(
  defineProps<{
    label: string
    icon: object
    activeClass?: string
    exact?: boolean
    to: string
  }>(),
  {
    activeClass: 'active',
    exact: false,
  },
)

const route = useRoute()
const isActive = computed(() => {
  if (!route?.path || !props.to) return false
  return props.exact ? route.path === props.to : route.path.startsWith(props.to)
})
</script>
